import { useSetAtom } from "jotai"
import { appClaimStakingPopupState } from "@/atoms/appPopupState"
import { REL } from "@/utils/constants"
import { tokenDecimalDigits, TokenSymbol } from "@/utils/helpers"
import { formatToken } from "@/utils/numberFormatter"
import { Link, Stack } from "@mui/material"
import NextLink from "next/link"
import Button from "@/components/base/Button"
import useRestaking from "@/hooks/useRestaking"
import useTrans from "@/hooks/useTrans"
import ItemInfo from "../../shared/ItemInfo"
import { useMemo } from "react"

const Claim = () => {
  const trans = useTrans()
  const { totalClaimable, rewardItemInfo } = useRestaking()

  // atoms
  const setClaimStakingPopupState = useSetAtom(appClaimStakingPopupState)

  const handleOpenClaimModal = () => {
    setClaimStakingPopupState({ isOpen: true })
  }

  const totalClaimableDisplay = useMemo(() => {
    if (!totalClaimable) return "0"

    return formatToken(
      totalClaimable,
      tokenDecimalDigits[(rewardItemInfo?.symbol as TokenSymbol) ?? REL],
      false,
      false,
      undefined,
      false,
      {},
    )
  }, [totalClaimable, rewardItemInfo?.symbol])

  return (
    <Stack gap={1} data-testid='staking-detail-claim'>
      <Stack direction='row' justifyContent='space-between' alignItems='start' gap={1}>
        <ItemInfo title={trans.staking.detail.total_claimable_verel} value={totalClaimableDisplay} />

        <Button
          variant='primary'
          size='md'
          className='w-32'
          onClick={handleOpenClaimModal}
          disabled={!totalClaimable || totalClaimable === 0}
          data-testid='restaking-claim-button'
        >
          {trans.staking.detail.claim}
        </Button>
      </Stack>
      <Link
        component={NextLink}
        href={trans.staking.detail.what_is_verel_link}
        target='_blank'
        className='text-primary hover:text-primary/80 text-sm font-semibold mt-4'
        data-testid='staking-detail-claim-learn-more-rel'
      >
        {trans.staking.detail.what_is_verel}
      </Link>
    </Stack>
  )
}

export default Claim
